import {
  AiReviewNoDataIcon,
  BrandVerifiedIcon
} from '@/components/common/icon';
import { useTranslation } from 'react-i18next';

/** Source labels describe real channel data, not whether the channel is linked. */
export default function CreatorAudienceSourceBadge({
  source,
  status
}: {
  source?: string;
  status?: string;
}) {
  const { t } = useTranslation();
  const verified = source === 'first_party';
  if (!verified && !(source === 'self_estimated' && status === 'success'))
    return null;

  return (
    <span
      className={`inline-flex h-[22px] shrink-0 items-center gap-1 rounded-full border px-2 text-xs font-medium leading-4 ${
        verified
          ? 'border-[#ABEFC6] bg-[#ECFDF3] text-[#067647]'
          : 'border-[#E9D5FF] bg-[#FAF5FF] text-[#7E22CE]'
      }`}
    >
      {verified ? (
        <BrandVerifiedIcon className="h-3.5 w-3.5 text-[#22C55E]" />
      ) : (
        <AiReviewNoDataIcon className="h-3 w-3" />
      )}
      {verified
        ? t('modal.modal_take_order.audience_demographics.verified_data', {
            defaultValue: 'Verified data'
          })
        : t('modal.modal_take_order.audience_demographics.ai_estimate', {
            defaultValue: 'AI estimate'
          })}
    </span>
  );
}
